import React from "react";
import classNames from "classnames";
import RippleEffect from "./RippleEffect";

const Info = ({
    as = 'button',
    href = '#',
    type = 'submit',
    processing,
    children,
    onClick,
    className = '',
    bgClass = '',
    isOutline = false,
    outlineClass = '',
    textClass = '',
    isRounded = false,
    roundedClass = '',
    isShadow = false,
    shadowClass = '',
    ...attrs
}) => {
    const classBtn = classNames(
        'px-4 py-2 lg:px-10 lg:py-4 font-semibold ripple text-nowrap text-center',
        {
            'text-white': !isOutline && textClass === '',
            'text-jellyfish-2': isOutline && textClass === '',
            'text-sm leading-none': textClass === '',
            [textClass]: textClass !== '',
            'bg-jellyfish-2 hover:bg-jellyfish-2/70': !isOutline && bgClass === '',
            'bg-white hover:bg-jellyfish-2/10': isOutline && bgClass === '',
            [bgClass]: bgClass !== '',
            'border border-jellyfish-2': isOutline && outlineClass === '',
            [outlineClass]: isOutline && outlineClass !== '',
            'rounded-full': isRounded && roundedClass === '',
            [roundedClass]: isRounded && roundedClass !== '',
            'shadow-lg': isShadow && shadowClass === '',
            [shadowClass]: isShadow && shadowClass !== '',
        },
        className,
    );

    return as === 'link' ? (
        <a href={href} onClick={onClick} className={classBtn} {...attrs}>
            {children}
            <RippleEffect />
        </a>
    ) : (
        <button
            type={type}
            onClick={onClick}
            className={classBtn}
            disabled={processing}
            {...attrs}
        >
            {children}
            <RippleEffect />
        </button>
    );
};

export default Info;
